/* eslint-disable no-unused-vars */
import { ISlotViewItem } from './interfaces/Slots/Slots';

export interface IExtraData {
  url: string;
  authRequired?: boolean;
  converter?: (data: unknown) => unknown;
}

export interface ISessionUrlData {
  url: string;
  method?: string;
  getQuery?: (params: any) => string;
  converter?: (data: any) => string;
  getBody?: (params: any) => object;
  getHeaders?: (params: any) => object;
}

export enum CasinoType {
  all = 'all',
  slots = 'slots',
  liveCasino = 'live-casino',
  virtualGames = 'virtual-games',
  crashGames = 'crash-games',
}

export interface ICasinoProviderConfigurationItem<CT> {
  multiProvider?: boolean;
  liveGamesProviders?: string[];
  uniqueField?: boolean;
  platform?: string[];
  gameListUrl: string;
  type: CasinoType;
  extraData?: IExtraData[];
  getHeaders?: (params: any) => object;
  defaultList?: boolean | ISlotViewItem[];
  converter: CT;
  sessionUrlData?: ISessionUrlData;
  authRequired?: boolean;
  method?: string;
  getBody?: (params?: any) => object;
  params?: object;
  gameListUrlData?: Pick<ISessionUrlData, 'getHeaders' | 'getBody' | 'getQuery'>;
}
export interface ICasinoProvidersConfiguration<CT> {
  [key: string]: ICasinoProviderConfigurationItem<CT>;
}

export interface ILangs {
  [key: string]: any;
}
